import * as React from 'react'

import NewPasswordSet from './NewPasswordSet'
import ResetRequestSend from './ResetRequestSend'

const PasswordReset: React.FC = () => {
  const [isRequestStep, setIsRequestStep] = React.useState(true)
  const [email, setEmail] = React.useState('')
  const onEnterEmail = (enteredEmail: string) => {
    setEmail(enteredEmail)
    setIsRequestStep(false)
  }

  return isRequestStep ? <ResetRequestSend onEnterEmail={onEnterEmail} /> : <NewPasswordSet email={email} />
}

export default PasswordReset
